import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { sanitizeIpeUserMessage } from '@/pages/ipe/workbench/utils/errorHandler';

export default function WorkbenchDetailPageHero({
  backLabel,
  onBack,
  icon,
  title,
  subtitle,
  metaItems = [],
  status,
  topActions,
  hints,
  failureHint,
  progressHint,
  variant = 'default',
}) {
  if (variant === 'goods') {
    return (
      <header className="img2img-detail__hero goods-detail__hero">
        <div className="goods-detail__hero-row">
          <button
            type="button"
            className="goods-detail__hero-back"
            onClick={onBack}
            aria-label={backLabel}
          >
            <ArrowLeft size={18} aria-hidden="true" />
          </button>
          <h1 className="img2img-detail__title">{title}</h1>
          {metaItems.length > 0 || status ? (
            <div className="img2img-detail__meta goods-detail__hero-meta">
              {metaItems.map((item) => (
                <span key={item.label} className="img2img-detail__meta-item">
                  <span className="img2img-detail__meta-label">{item.label}</span>
                  <span className="img2img-detail__meta-value">{item.value}</span>
                </span>
              ))}
              {status ? (
                <span className={`img2img-detail__status img2img-detail__status--${status.className}`}>
                  {status.label}
                </span>
              ) : null}
            </div>
          ) : null}
          {topActions ? (
            <div className="goods-detail__hero-top-actions">{topActions}</div>
          ) : null}
        </div>
        {failureHint ? <p className="goods-detail__failure-hint">{sanitizeIpeUserMessage(failureHint)}</p> : null}
        {progressHint ? <p className="goods-detail__progress-hint">{progressHint}</p> : null}
        {hints?.length ? (
          <div className="img2img-detail__hero-hints">
            {hints.map((hint) => (
              <p key={hint} className="img2img-detail__hero-hint">
                {hint}
              </p>
            ))}
          </div>
        ) : null}
      </header>
    );
  }

  return (
    <header className="img2img-detail__hero">
      <div className="img2img-detail__hero-top">
        <button type="button" className="img2img-detail__back-btn" onClick={onBack}>
          <ArrowLeft size={16} aria-hidden="true" />
          {backLabel}
        </button>
        {topActions ? <div className="img2img-detail__hero-top-actions">{topActions}</div> : null}
      </div>
      <div className="img2img-detail__hero-main">
        {icon ? (
          <div className="img2img-detail__hero-icon" aria-hidden="true">
            {icon}
          </div>
        ) : null}
        <div className="img2img-detail__hero-copy">
          <h1 className="img2img-detail__title">{title}</h1>
          {subtitle ? <p className="img2img-detail__subtitle">{subtitle}</p> : null}
        </div>
      </div>
      {metaItems.length > 0 || status ? (
        <div className="img2img-detail__meta">
          {metaItems.map((item) => (
            <span key={item.label} className="img2img-detail__meta-item">
              <span className="img2img-detail__meta-label">{item.label}</span>
              <span className="img2img-detail__meta-value">{item.value}</span>
            </span>
          ))}
          {status ? (
            <span className={`img2img-detail__status img2img-detail__status--${status.className}`}>
              {status.label}
            </span>
          ) : null}
        </div>
      ) : null}
      {failureHint ? <p className="goods-detail__failure-hint">{sanitizeIpeUserMessage(failureHint)}</p> : null}
      {progressHint ? <p className="goods-detail__progress-hint">{progressHint}</p> : null}
      {hints?.length ? (
        <div className="img2img-detail__hero-hints">
          {hints.map((hint) => (
            <p key={hint} className="img2img-detail__hero-hint">
              {hint}
            </p>
          ))}
        </div>
      ) : null}
    </header>
  );
}
